module.exports = __webpack_public_path__ + "img/xcxm.5acec1b2.jpg";